import { TankShape } from './enums';
import { ModelCommon, UserAttributeDef, UserAttributeDefs, toDatePickerFormat, ValidModelType } from '@iotv/datamodel-core';
import { isValidBusinessObject, MapLike, PathDirection, Position } from '@iotv/iotv-v3-types';

const typeName = 'Trough';

export type TroughProps = {
  purpose?: string;
  capacity?: number;
  currentVolume?: number;
  diameter?: number;
  depthHeight?: number;
  shape?: TankShape;
  width?: number;
  length?: number;
  constructionMaterial?: string;
  location?: Position;
  image?: string;
};

export class Trough extends ModelCommon {
  constructor(ob: any) {
    super(ob.type || typeName, ob);
  }

  purpose?: string;
  capacity?: number;
  currentVolume?: number;
  diameter?: number;
  depthHeight?: number;
  shape?: TankShape;
  width?: number;
  length?: number;
  constructionMaterial?: string;
  location?: Position;
  image?: string;

  getUserAttributes(): UserAttributeDefs {
    return {
      ...super.getUserAttributes(),
      name: { type: 'String', editable: true, label: 'Name', name: 'name', description: 'Name of Trough' },
      purpose: { type: 'String', editable: true, label: 'Purpose', name: 'purpose', description: 'Used for' },
      capacity: { type: 'Number', editable: true, label: 'Capacity', name: 'capacity', description: 'Total storage capacity of Trough in m3 and litres' },
      currentVolume: { type: 'Number', editable: true, label: 'Current Volume', name: 'currentVolume', description: 'Current volume in the trough' },
      diameter: { type: 'Number', editable: true, label: 'Diameter', name: 'diameter', description: 'Diameter of Trough - metre.cm' },
      depthHeight: { type: 'Number', editable: true, label: 'Depth/ height', name: 'depth/Height', description: 'Depth/ Height of Trough in m.cm' },
      shape: { type: 'Enum', editable: true, label: 'Shape', name: 'shape', description: 'Cylinder, rectangle, other', enumKv: TankShape },
      width: { type: 'Number', editable: true, label: 'Width', name: 'width', description: 'Width if rectangle' },
      length: { type: 'Number', editable: true, label: 'Length ', name: 'length', description: 'Length if rectangle' },
      constructionMaterial: {
        type: 'String',
        editable: true,
        label: 'Construction material',
        name: 'constructionMaterial',
        description: 'Material Trough is contructed from',
      },
      location: { type: 'object', editable: true, label: 'Location', name: 'location', description: 'Location of  Trough (lat/ long)' },
      image: { type: 'String', editable: true, label: 'Image', name: 'image', description: 'Photograph of Trough' },
      comments: { type: 'String', editable: true, label: 'Comments', name: 'comments', description: 'Free text for info ' },
    };
  };
}
